//Please add the language resource
const carrierAging = {

  itrCode:'ItrCode',
  orderTypeName:'OrderTypeName',
  carrierNo: 'CarrierNo',
  carrierName: 'CarrierName',
  consigneeCode: 'ConsigneeCode',
  consigneeAddrShort:'ConsigneeAddrShort',
  expectedDeliveryDate:'ExpectedDeliveryDate',
  epodUploadTime:'EpodUploadTime',

  truckNo:'TruckNo',
  planExpToTime:'PlanExpToTime',
  inTime:'InTime',
  outTime: 'OutTime',
  planExpDiffDay:'PlanExpDiffDay',
  actArriveTime:'ActArriveTime',
  actArriveDiffDay:'ActArriveDiffDay',
  epodUploadDiffDay:'EpodUploadDiffDay',

  msg:{
  }
};
export default carrierAging



// WEBPACK FOOTER //
// ./src/page/report/carrierAging/lang/carrierAging.en.js